import React from "react"
import Components from "../index"
import { blokType, sbAssetType } from "../../types"

import {
  StyledCardHover,
  StyledCardContainer,
  StyledText,
  StyledTextContainer,
  StyledTitleWrapper,
  StyledTitle,
  StyledDescWrapper,
  StyledDesc,
  StyledCardButton,
  StyledCardLinkWrapper,
  StyledCardLink,
} from "./partials"

export interface CardHoverProps {
  title: string
  description: string
  button: blokType[]
  background_image: sbAssetType
  card_link: blokType[]
  minimum_height: boolean
}

export const CardHoverCmp: React.FC<CardHoverProps> = ({
  title,
  description,
  button,
  background_image,
  card_link,
  minimum_height,
}) => {
  return (
    <StyledCardHover
      background_image={background_image ? background_image.filename : ""}
      minimum_height={minimum_height}
    >
      <StyledCardContainer>
        {card_link && (
          <StyledCardLinkWrapper>
            {card_link.length > 0 && (
              <StyledCardLink>
                {card_link.map((l) =>
                  React.createElement(Components(l.component), {
                    key: l._uid,
                    blok: l,
                  })
                )}
              </StyledCardLink>
            )}
          </StyledCardLinkWrapper>
        )}

        <StyledText>
          <StyledTextContainer>
            <StyledTitleWrapper>
              {title && <StyledTitle>{title}</StyledTitle>}
            </StyledTitleWrapper>
            <StyledDescWrapper>
              {description && <StyledDesc>{description}</StyledDesc>}
            </StyledDescWrapper>
          </StyledTextContainer>
          {button && button.length > 0 && (
            <StyledCardButton>
              {button.map((content: blokType) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              )}
            </StyledCardButton>
          )}
        </StyledText>
      </StyledCardContainer>
    </StyledCardHover>
  )
}